import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

interface ParamEntry {
  name: string;
  type: 'string' | 'number' | 'object';
  value: string | number | object;
}

@Component({
  selector: 'prebid-optional-params',
  templateUrl: './prebid-optional-params.component.html',
  styleUrls: ['./prebid-optional-params.component.scss'],
})
export class PrebidOptionalParamsComponent implements OnChanges {
  @Input() value: object = {};
  @Input() depth: number = 0;
  @Output() valueChange = new EventEmitter<object>();

  public params: ParamEntry[] = [];

  private building = false;

  ngOnChanges(): void {
    if (this.building) {
      return;
    }
    this.params = this.objectToParams(this.value || {});
  }

  private objectToParams(obj: object): ParamEntry[] {
    return Object.keys(obj).map((key) => {
      const val = obj[key];
      const type = this.detectType(val);
      return { name: key, type, value: val };
    });
  }

  private detectType(val: any): 'string' | 'number' | 'object' {
    if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
      return 'object';
    }
    if (typeof val === 'number') {
      return 'number';
    }
    return 'string';
  }

  addParam(): void {
    this.params.push({ name: '', type: 'string', value: '' });
  }

  removeParam(i: number): void {
    this.params.splice(i, 1);
    this.emitChange();
  }

  onTypeChange(i: number, type: 'string' | 'number' | 'object'): void {
    this.params[i].type = type;
    this.params[i].value = type === 'object' ? {} : type === 'number' ? 0 : '';
    this.emitChange();
  }

  onNameChange(i: number, name: string): void {
    this.params[i].name = name;
    this.emitChange();
  }

  onValueChange(i: number, val: string | number): void {
    this.params[i].value = val;
    this.emitChange();
  }

  onNestedChange(i: number, obj: object): void {
    this.params[i].value = obj;
    this.emitChange();
  }

  emitChange(): void {
    this.building = true;
    const result: object = {};
    for (const p of this.params) {
      if (p.name) {
        result[p.name] = p.type === 'number' ? +p.value : p.value;
      }
    }
    this.valueChange.emit(result);
    setTimeout(() => { this.building = false; }, 0);
  }
}
